import {getStore, setStore} from '@/utils/store'

const params = {
  state: {
    userCode: getStore({name: 'userCode'}) || '', // 用户账户ID
    teamCode: getStore({name: 'teamCode'}) || '', // 团队编码
    dataType: getStore({name: 'dataType'}) || 0, // 0-团队个人数据 1-团队数据 2-团队数据 + 队长个人数据
    teamCodeBelong: getStore({name: 'teamCodeBelong'}) || '' // 队长所属团队编码
  },
  actions: {},
  mutations: {
    SET_USER_CODE (state, userCode) {
      state.userCode = userCode
      setStore({
        name: 'userCode',
        content: state.userCode
      })
    },
    SET_TEAM_CODE (state, teamCode) {
      state.teamCode = teamCode
      setStore({
        name: 'teamCode',
        content: state.teamCode
      })
    },
    SET_DATA_TYPE (state, dataType) {
      state.dataType = dataType
      setStore({
        name: 'dataType',
        content: state.dataType
      })
    },
    SET_TEAM_CODE_BELONG (state, teamCodeBelong) {
      state.teamCodeBelong = teamCodeBelong
      setStore({
        name: 'teamCodeBelong',
        content: state.teamCodeBelong
      })
    }
  }
}

export default params



// WEBPACK FOOTER //
// ./src/store/modules/params.js